(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerBounds = {};
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }
    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }
    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }
    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }
    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }
  customElements.define('sticky-header', StickyHeader);
  const stickyHeader = document.querySelector('sticky-header');
  if(!stickyHeader || stickyHeader == null){ 
    document.documentElement.style.setProperty('--header-height', `0px`);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sportszone-release-spotlight"] && !Shopify.designMode) return;
  try {
    
(() => {
  const countClasses = ['sz-drops--count-1','sz-drops--count-2','sz-drops--count-3','sz-drops--count-4','sz-drops--count-5','sz-drops--count-6'];
  const headings = { hockey:'Latest Hockey Drops', goalie:'Latest Goalie Drops', baseball:'Latest Baseball Drops', softball:'Latest Softball Drops' };
  const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const init = (root) => {
    if (!root || root.dataset.szDropsReady === 'true') return;
    const tabs = [...root.querySelectorAll('[data-sz-drop-tab]')];
    const cards = [...root.querySelectorAll('[data-sz-drop-card]')];
    const rail = root.querySelector('[data-sz-drops-rail]');
    const heading = root.querySelector('[data-sz-drops-heading]');
    const maxVisible = Math.max(1, parseInt(root.dataset.maxVisible || '6', 10) || 6);
    const baseHeading = heading?.dataset.baseHeading || heading?.textContent?.trim() || 'Latest drops';
    if (!tabs.length || !cards.length) return;
    root.dataset.szDropsReady = 'true';

    const apply = (sport) => {
      let visible = 0;
      cards.forEach((card) => {
        const match = sport === 'all' || card.dataset.sport === sport;
        const show = match && visible < maxVisible;
        card.hidden = !show;
        if (show) visible += 1;
      });
      countClasses.forEach((name) => root.classList.remove(name));
      root.classList.add(`sz-drops--count-${Math.max(1, Math.min(visible, 6))}`);
      tabs.forEach((tab) => {
        const active = tab.dataset.szDropTab === sport;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      if (heading) heading.textContent = sport === 'all' ? baseHeading : (headings[sport] || baseHeading);
      rail?.scrollTo({ left:0, behavior:reduced() ? 'auto' : 'smooth' });
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => apply(tab.dataset.szDropTab || 'all'));
      tab.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        const direction = event.key === 'ArrowRight' ? 1 : -1;
        tabs[(index + direction + tabs.length) % tabs.length].focus();
      });
    });
    apply('all');
  };

  const initAll = (scope = document) => {
    if (scope.matches?.('[data-sz-drops]')) init(scope);
    scope.querySelectorAll?.('[data-sz-drops]').forEach(init);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll()); else initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
